<template>
    <mvtOverlay ref="overlay" class="property-overlayer">
        <div class="property-pop" ref="scroller" data-role="scroller">
            <div class="property-pop-header">
                <button type="button" class="property-pop-close color-l1" @click="close"><i class="icon-angle-left"></i></button>
                <slot name="header"/>
                <dppButton id="popDppButtons" class="f6"></dppButton>
            </div>
            <div class="property-pop-body">
                <slot name="body"/>
                <div class="hotlead-button">
                    <dppHotleadButton></dppHotleadButton>
                </div>
            </div>
        </div>
    </mvtOverlay>
</template>
<script src="./property-pop.js"></script>

<style lang="scss">
@use "./property-pop.scss" as *;
</style>
